var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 35,
    height: 35,
    rx: 7.5,
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.0002 15.4434C16.5834 15.4434 15.4326 16.5971 15.4326 18.0174C15.4326 19.4378 16.5834 20.5943 18.0002 20.5943C19.417 20.5943 20.5706 19.4378 20.5706 18.0174C20.5706 16.5971 19.417 15.4434 18.0002 15.4434Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8752 11H14.1248C12.4028 11 11 12.4063 11 14.1327V21.9027C11 23.6318 12.4028 25.0354 14.1248 25.0354H21.8752C23.6 25.0354 25 23.6318 25 21.9027V14.1327C25 12.4063 23.6 11 21.8752 11ZM18 22.5651C15.4996 22.5651 13.464 20.5244 13.464 18.0177C13.464 15.511 15.4996 13.473 18 13.473C20.5004 13.473 22.536 15.511 22.536 18.0177C22.536 20.5244 20.5004 22.5651 18 22.5651ZM22.6312 14.2983C22.102 14.2983 21.6708 13.8688 21.6708 13.3383C21.6708 12.8078 22.102 12.3755 22.6312 12.3755C23.1604 12.3755 23.5916 12.8078 23.5916 13.3383C23.5916 13.8688 23.1604 14.2983 22.6312 14.2983Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.2aa237477d0c7df7e3a81dc0b28f8904.svg";
export { ForwardRef as ReactComponent };